module.exports = __webpack_public_path__ + "static/media/Baskervald Italic-01.60ad9297.svg";